import { useEffect } from 'react';

const defaultTitle = process.env.REACT_APP_HTML_TITLE;

const useTitleBasedOnMatch = (match, tabTitle) => {
  useEffect(() => {
    if (!match) {
      return;
    }

    const title = match ? `${tabTitle} - ${defaultTitle}` : defaultTitle;

    document.title = title;

    return () => {
      document.title = defaultTitle;
    };
  }, [match, tabTitle]);
};

export default useTitleBasedOnMatch;
